(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2],{

/***/ 6245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InvalidTokenError */
function e(e){this.message=e}e.prototype=new Error,e.prototype.name="InvalidCharacterError";var r="undefined"!=typeof window&&window.atob&&window.atob.bind(window)||function(r){var t=String(r).replace(/=+$/,"");if(t.length%4==1)throw new e("'atob' failed: The string to be decoded is not correctly encoded.");for(var n,o,a=0,i=0,c="";o=t.charAt(i++);~o&&(n=a%4?64*n+o:o,a++%4)?c+=String.fromCharCode(255&n>>(-2*a&6)):0)o="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);return c};function t(e){var t=e.replace(/-/g,"+").replace(/_/g,"/");switch(t.length%4){case 0:break;case 2:t+="==";break;case 3:t+="=";break;default:throw"Illegal base64url string!"}try{return function(e){return decodeURIComponent(r(e).replace(/(.)/g,(function(e,r){var t=r.charCodeAt(0).toString(16).toUpperCase();return t.length<2&&(t="0"+t),"%"+t})))}(t)}catch(e){return r(t)}}function n(e){this.message=e}function o(e,r){if("string"!=typeof e)throw new n("Invalid token specified");var o=!0===(r=r||{}).header?0:1;try{return JSON.parse(t(e.split(".")[o]))}catch(e){throw new n("Invalid token specified: "+e.message)}}n.prototype=new Error,n.prototype.name="InvalidTokenError";/* harmony default export */ __webpack_exports__["Z"] = (o);
//# sourceMappingURL=jwt-decode.esm.js.map


/***/ }),

/***/ 8559:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/success",
      function () {
        return __webpack_require__(2750);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zW": function() { return /* binding */ Events; },
  "sn": function() { return /* binding */ PageNames; },
  "c7": function() { return /* binding */ PageTypes; },
  "Vk": function() { return /* binding */ handleAccountPageEvent; },
  "qH": function() { return /* binding */ handleHomePageEvent; },
  "GV": function() { return /* binding */ handleTrackEvent; },
  "jV": function() { return /* binding */ mountDataLayer; },
  "l9": function() { return /* binding */ setPageAnalyticsData; }
});

// UNUSED EXPORTS: EventTypes, generatePageName

// EXTERNAL MODULE: ./node_modules/react-cookie/es6/Cookies.js
var Cookies = __webpack_require__(5501);
// EXTERNAL MODULE: ./lib/analytics/segment/index.ts + 2 modules
var segment = __webpack_require__(4292);
;// CONCATENATED MODULE: ./lib/analytics/index.ts

var initiated = false;
var LCP_TIME = 6000;
var init = function() {
    window.segmentFlushQueue = flushQueue;
    if (initiated) return true;
    initSegment();
    initiated = true;
    window.addEventListener('unload', function() {
        flushQueue();
    });
    return initiated;
};
var handleAnalytics = function(event) {
    (0,segment/* segmentTrackEvent */.R7)(event);
};
var timedOutInit = function() {
    if (initiated) return true;
    setTimeout(function() {
        return init();
    }, LCP_TIME);
    return true;
};

// EXTERNAL MODULE: ./constants/index.ts
var constants = __webpack_require__(1407);
// EXTERNAL MODULE: ./lib/utils/helper.ts
var helper = __webpack_require__(9981);
// EXTERNAL MODULE: ./lib/utils/getConfig.ts + 1 modules
var getConfig = __webpack_require__(889);
;// CONCATENATED MODULE: ./lib/analytics/trackCalls.ts





function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var EventTypes;
(function(EventTypes) {
    EventTypes["PAGE"] = 'page';
    EventTypes["TRACK"] = 'track';
})(EventTypes || (EventTypes = {}));
var Events;
(function(Events) {
    Events["BUTTON_LINK_SELECTED"] = 'Button Link Selected';
    Events["SUBMIT"] = 'Submit';
    Events["SUBMIT_CODE_LANDING"] = 'Submit Code Landing';
    Events["SUBMIT_CODE_STARTED"] = 'Submit Code Started';
    Events["SUBMIT_CODE_COMPLETED"] = 'Submit Code Completed';
    Events["PROFILE_ACCESS_ACTIVATION_STARTED"] = 'Profile Access Activation Started';
    Events["PROFILE_ACCESS_ACTIVATION_COMPLETED"] = 'Profile Access Activation Completed';
    Events["PROFILE_ACCESS_ACTIVATION_ERROR"] = 'Profile Access Activation Error';
    Events["PROFILE_INITIATED"] = 'Profile Initiated';
    Events["PROFILE_PROMPT_LANDING"] = 'Profile Prompt Landing';
    Events["PROFILE_SIGN_IN_STARTED"] = 'Profile Sign In Started';
    Events["PROFILE_SIGN_UP_STARTED"] = 'Profile Sign Up Started';
    Events["PROFILE_SIGN_IN_COMPLETED"] = 'Profile Sign In Completed';
    Events["PROFILE_SIGN_UP_COMPLETED"] = 'Profile Sign Up Completed';
})(Events || (Events = {}));
var FOX_PREFIX = 'delta';
var NATION_PREFIX = 'nation';
var SPORT_PREFIX = 'nation sport';
var PageNames;
(function(PageNames) {
    PageNames["SUBMIT_CODE_LANDING"] = 'submit code landing';
    PageNames["PROFILE_PROMPT_LANDING"] = 'profile prompt:landing';
})(PageNames || (PageNames = {}));
var PageTypes;
(function(PageTypes) {
    PageTypes["ACTIVATION_CODE"] = 'activation code';
    PageTypes["PROFILE_PROMPT"] = 'profile prompt';
})(PageTypes || (PageTypes = {}));
var _obj;
var getClientPrefix = (_obj = {}, _defineProperty(_obj, constants/* Brand.FOX */.H2.FOX, FOX_PREFIX), _defineProperty(_obj, constants/* Brand.SPORTS */.H2.SPORTS, SPORT_PREFIX), _defineProperty(_obj, constants/* Brand.NATION */.H2.NATION, NATION_PREFIX), _obj);
var ACTIVATION_METHOD = '2nd screen';
var APP_PLATFORM = 'web';
var FOX = 'fox';
var FOX_DOMAIN = 'fox.com';
var NATION_DOMAIN = 'foxnews.com';
var ANONYMOUS_ID_COOKIE = 'lastAnonymousProfileId';
var PAGE_TYPE = 'ott';
var PRIMARY_BUSINESS_UNIT = 'fng';
var PROFILE_ID_COOKIE = 'secondScreenProfileId';
var START_SOURCE = 'general';
var APP_CLIENT_PREFIX = getClientPrefix["fox"];
var defaultTraits = {
    appsflyer_id: '',
    dcg_profile_id: '',
    lastAnonymousProfileId: '',
    lastKnownProfileId: '',
    mvpd: '',
    network_entitlement_list: '',
    us_privacy: ''
};
// TODO: Update BRAND and DEVICE for Nation
// const DEVICE = account?.device ?? 'FOX';
var BRAND = FOX;
var DEVICE = 'FOX';
var defaultProps = {
    app_name: "fox" || 0,
    app_platform: APP_PLATFORM,
    // TODO: set app version dynamically
    app_version: '1.0.0',
    page_name: ACTIVATION_METHOD,
    page_profile_activation_method: ACTIVATION_METHOD,
    page_start_source: START_SOURCE,
    page_type: PAGE_TYPE,
    primary_business_unit: PRIMARY_BUSINESS_UNIT,
    secondary_business_unit: "fox" || 0
};
var handleTrackEvent = function() {
    for(var _len = arguments.length, events = new Array(_len), _key = 0; _key < _len; _key++){
        events[_key] = arguments[_key];
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = events[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _value = _step.value, eventName = _value.eventName, props = _value.props, context = _value.context, eventType = _value.eventType;
            var ref, ref1;
            var cookies = new Cookies/* default */.Z();
            var ref2;
            var profileId = (ref2 = cookies.get(PROFILE_ID_COOKIE)) !== null && ref2 !== void 0 ? ref2 : '';
            var ref3;
            var codeInfoCookie = (ref3 = cookies.get(constants/* COOKIE_CODE_INFO */.r5)) !== null && ref3 !== void 0 ? ref3 : {};
            var campaignCodes = fetchCampaignCodes();
            // TODO: Find out why campaignCodes are different for different events
            if (eventName === Events.PROFILE_ACCESS_ACTIVATION_COMPLETED) {
                var ref4;
                var compaignCodesCookie = (ref4 = cookies.get(constants/* COOKIE_CAMPAIGN_CODES */.gV)) !== null && ref4 !== void 0 ? ref4 : '';
                campaignCodes = parseCampaignParams(compaignCodesCookie);
            }
            var traits = _objectSpread({}, defaultTraits, campaignCodes, {
                dcg_profile_id: profileId,
                lastAnonymousProfileId: getAnonymousId(),
                lastKnownProfileId: profileId
            });
            var ref5;
            var argsPageName = (ref5 = props === null || props === void 0 ? void 0 : props.page_name) !== null && ref5 !== void 0 ? ref5 : null;
            var ref6;
            var currentPageName = (ref6 = (ref = window.DataLayer) === null || ref === void 0 ? void 0 : ref.page_name) !== null && ref6 !== void 0 ? ref6 : null;
            var pageName = argsPageName !== null && argsPageName !== void 0 ? argsPageName : currentPageName;
            var genericPageName = generatePageName({
                pageName: pageName
            });
            var ref7;
            var argsPageType = (ref7 = props === null || props === void 0 ? void 0 : props.page_type) !== null && ref7 !== void 0 ? ref7 : null;
            var ref8;
            var currentPageType = (ref8 = (ref1 = window.DataLayer) === null || ref1 === void 0 ? void 0 : ref1.page_type) !== null && ref8 !== void 0 ? ref8 : null;
            var pageType = argsPageType !== null && argsPageType !== void 0 ? argsPageType : currentPageType;
            var ref9;
            var argsActivationCode = (ref9 = props === null || props === void 0 ? void 0 : props.page_activation_code) !== null && ref9 !== void 0 ? ref9 : null;
            var _code;
            var currentActiovationCode = (_code = codeInfoCookie.code) !== null && _code !== void 0 ? _code : null;
            var activationCode = argsActivationCode !== null && argsActivationCode !== void 0 ? argsActivationCode : currentActiovationCode;
            var newContext = _objectSpread({}, context, {
                traits: traits
            });
            var finalProps = (0,helper.cleanObject)(_objectSpread({}, defaultProps, {
                page_name: genericPageName,
                page_type: pageType,
                page_activation_code: activationCode
            }, props));
            handleAnalytics({
                eventName: eventName,
                props: finalProps,
                eventType: eventType,
                context: newContext
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
};
var generatePageName = function(param) {
    var pageName = param.pageName;
    return "".concat(APP_CLIENT_PREFIX, ":").concat(APP_PLATFORM, ":").concat(pageName);
};
var handleHomePageEvent = function() {
    handleTrackEvent({
        eventName: Events.PROFILE_ACCESS_ACTIVATION_STARTED
    }, {
        eventName: Events.SUBMIT_CODE_STARTED
    }, {
        eventName: Events.SUBMIT_CODE_LANDING,
        eventType: EventTypes.PAGE
    });
};
var handleAccountPageEvent = function() {
    handleTrackEvent({
        eventName: Events.PROFILE_PROMPT_LANDING,
        eventType: EventTypes.PAGE
    });
};
var getAnonymousId = function() {
    var ref;
    var cookies = new Cookies/* default */.Z();
    var user = (ref = window.analytics) === null || ref === void 0 ? void 0 : ref.user;
    var ref10;
    var lastAnonymousProfileId = (ref10 = cookies.get(ANONYMOUS_ID_COOKIE)) !== null && ref10 !== void 0 ? ref10 : '';
    var networkDomain;
    if (BRAND === FOX) networkDomain = FOX_DOMAIN;
    else networkDomain = NATION_DOMAIN;
    if (lastAnonymousProfileId) {
        cookies.set(ANONYMOUS_ID_COOKIE, lastAnonymousProfileId, {
            domain: networkDomain
        });
        return lastAnonymousProfileId;
    }
    var anonymousId = user ? user().anonymousId() : null;
    // TODO: Finds out why it is here
    cookies.set(ANONYMOUS_ID_COOKIE, anonymousId, {
        domain: networkDomain
    });
    return anonymousId;
};
var mountDataLayer = function() {
    window.DataLayer = {};
};
var setPageAnalyticsData = function(param) {
    var pageName = param.pageName, pageType = param.pageType;
    if (!window.DataLayer) mountDataLayer();
    window.DataLayer.page_name = pageName;
    window.DataLayer.page_type = pageType;
};
var parseCampaignParams = function(queryString) {
    if (!queryString) return {};
    var cleanQueryString = queryString.split('undefinedUnknown')[0];
    var segmentCampaign = 'cmpid';
    var propertyNames = {
        cmpid: 'campaign_int_tracking_code',
        int_cmp: 'campaign_int_name'
    };
    var params = {};
    var ref13;
    var cleanCampaignString = (ref13 = cleanQueryString.match(/^[^&]*/)) !== null && ref13 !== void 0 ? ref13 : '';
    var ref11;
    var campaignString = (ref11 = cleanCampaignString[0]) !== null && ref11 !== void 0 ? ref11 : '';
    params[propertyNames[segmentCampaign]] = campaignString;
    var campaignCodes = campaignString.split('::');
    (campaignCodes || []).forEach(function(codes) {
        var keyValuesPair = codes.split('=');
        if (keyValuesPair.length === 2) {
            var ref;
            var key = (ref = keyValuesPair[0]) !== null && ref !== void 0 ? ref : '';
            var ref12;
            var value = (ref12 = keyValuesPair[1]) !== null && ref12 !== void 0 ? ref12 : '';
            var _key;
            var property = (_key = propertyNames[key]) !== null && _key !== void 0 ? _key : '';
            params[property] = value;
        }
    });
    return (0,helper.cleanObject)(params);
};
var fetchCampaignCodes = function() {
    var ref;
    var intCmp = (ref = getParameterByName(constants/* INT_CMP */.vl)) !== null && ref !== void 0 ? ref : null;
    // if (intCmp == null) return null;
    var intOrg = 'dcg';
    // TODO: Get brand from
    var intMc = BRAND;
    var ref14;
    var intSrc = (ref14 = getDeviceFromProvidersByKey()) !== null && ref14 !== void 0 ? ref14 : DEVICE;
    var intAdd = intMc + (intSrc ? '_' + intSrc : '') + (intCmp ? '_' + intCmp : '');
    var codes = (0,helper.cleanObject)({
        int_org: intOrg,
        int_mc: intMc !== null && intMc !== void 0 ? intMc : null,
        int_src: intSrc !== null && intSrc !== void 0 ? intSrc : null,
        int_cmp: intCmp !== null && intCmp !== void 0 ? intCmp : null,
        int_add: intAdd !== null && intAdd !== void 0 ? intAdd : null
    });
    codes.campaign_int_tracking_code = formatCampaignString(codes);
    return codes;
};
var getParameterByName = function getParameterByName(name) {
    var match = RegExp('[?&]' + name + '=([^&]*)').exec(window === null || window === void 0 ? void 0 : window.location.search);
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
};
var formatCampaignString = function(campaignCodes) {
    var campaignKeys = Object.keys(campaignCodes);
    return campaignKeys.reduce(function(acc, key, i) {
        var isLast = i === campaignKeys.length - 1;
        return acc + key + '=' + campaignCodes[key] + (!isLast ? '::' : '');
    }, '');
};
var getDeviceFromProvidersByKey = function() {
    var cookies = new Cookies/* default */.Z();
    var ref;
    var codeInfoCookie = (ref = cookies.get(constants/* COOKIE_CODE_INFO */.r5)) !== null && ref !== void 0 ? ref : '';
    var config = (0,getConfig/* getConfig */.i)();
    var ref15;
    var devices = (ref15 = config === null || config === void 0 ? void 0 : config.devices) !== null && ref15 !== void 0 ? ref15 : [];
    Object.entries(devices).forEach(function(element) {
        var deviceName = element[0];
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        var providerKeys = element[1]['providers-key'];
        if (providerKeys === codeInfoCookie || deviceName === providerKeys) return element;
    });
    return null;
};


/***/ }),

/***/ 2750:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _home_jenkins_workspace_dcg_web_PROD_go_fox_com_static_s3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _home_jenkins_workspace_dcg_web_PROD_go_fox_com_static_s3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_jenkins_workspace_dcg_web_PROD_go_fox_com_static_s3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1163);
/* harmony import */ var react_cookie__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(708);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(7379);
/* harmony import */ var styles_colors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2317);
/* harmony import */ var styles_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9900);
/* harmony import */ var jwt_decode__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6245);
/* harmony import */ var lib_utils_configs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2670);
/* harmony import */ var lib_utils_helper__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9981);
/* harmony import */ var lib_analytics_trackCalls__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5537);
/* harmony import */ var context_GlobalContextProvider__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1387);
/* harmony import */ var context_state_reducer__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(2807);
/* harmony import */ var components_common__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2513);
/* harmony import */ var constants_index__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(1407);
/* provided dependency */ var process = __webpack_require__(3454);
















function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    max-width: 500px;\n    margin: auto;\n    padding-top: 6rem;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  padding-top: 3rem;\n  margin: 0 auto;\n  height: 100%;\n  font-size: 16px;\n  text-align: center;\n  ",
        "\n  h1 {\n    font-family: 'Graphik', serif;\n    font-size: 30px;\n    font-weight: 600;\n    letter-spacing: -0.38px;\n    line-height: 37px;\n    text-align: center;\n  }\n\n  p {\n    margin: 0 0 1.5rem;\n    color: ",
        ";\n    font-family: 'Graphik', serif;\n    font-size: 24px;\n    font-weight: 300;\n    font-style: normal;\n    letter-spacing: -0.3px;\n    line-height: 30px;\n    opacity: 0.5;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var Success = function(param) {
    var profile = param.profile;
    var ref5;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(context_GlobalContextProvider__WEBPACK_IMPORTED_MODULE_10__/* .AppContext */ .I), state = ref1.state, dispatch = ref1.dispatch;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var ref2 = _slicedToArray((0,react_cookie__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)([
        constants_index__WEBPACK_IMPORTED_MODULE_13__/* .ACCOUNT_COOKIE_NAME_FOX */ .EO,
        constants_index__WEBPACK_IMPORTED_MODULE_13__/* .COOKIE_CODE_INFO */ .r5
    ]), 1), cookies = ref2[0];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!(profile === null || profile === void 0 ? void 0 : profile.checkAdobeAuthN)) return;
        var updatedProfile;
        var successTimer;
        var validateAuth = function() {
            var _ref1 = _asyncToGenerator(_home_jenkins_workspace_dcg_web_PROD_go_fox_com_static_s3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee1() {
                var ref6, ref3, accessToken, ref4, _COOKIE_CODE_INFO, codeInfoCookie, firstScreenDeviceId, authNResponse, accessToken1, mvpd, redirect;
                return _home_jenkins_workspace_dcg_web_PROD_go_fox_com_static_s3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx1) {
                    while(1)switch(_ctx1.prev = _ctx1.next){
                        case 0:
                            ;
                            _ctx1.next = 3;
                            return (0,lib_utils_helper__WEBPACK_IMPORTED_MODULE_8__.setConfigToProfile)(profile, {
                                appName: lib_utils_configs__WEBPACK_IMPORTED_MODULE_7__/* .profileConfig.appName */ .Vc.appName,
                                appVersion: lib_utils_configs__WEBPACK_IMPORTED_MODULE_7__/* .profileConfig.appVersion */ .Vc.appVersion,
                                accessToken: (ref6 = cookies[constants_index__WEBPACK_IMPORTED_MODULE_13__/* .ACCOUNT_COOKIE_NAME_FOX */ .EO]) === null || ref6 === void 0 ? void 0 : ref6.accessToken
                            });
                        case 3:
                            updatedProfile = _ctx1.sent;
                            accessToken = (0,jwt_decode__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((ref3 = cookies[constants_index__WEBPACK_IMPORTED_MODULE_13__/* .ACCOUNT_COOKIE_NAME_FOX */ .EO]) === null || ref3 === void 0 ? void 0 : ref3.accessToken);
                            _ctx1.prev = 5;
                            if (!(0,lib_utils_helper__WEBPACK_IMPORTED_MODULE_8__.tokenValid)(accessToken)) {
                                _ctx1.next = 25;
                                break;
                            }
                            ;
                            ;
                            codeInfoCookie = (_COOKIE_CODE_INFO = cookies[constants_index__WEBPACK_IMPORTED_MODULE_13__/* .COOKIE_CODE_INFO */ .r5]) !== null && _COOKIE_CODE_INFO !== void 0 ? _COOKIE_CODE_INFO : {};
                            firstScreenDeviceId = codeInfoCookie.firstScreenDeviceId;
                            _ctx1.next = 13;
                            return updatedProfile === null || updatedProfile === void 0 ? void 0 : (ref4 = updatedProfile.checkAdobeAuthN) === null || ref4 === void 0 ? void 0 : ref4.call(updatedProfile, {
                                deviceId: firstScreenDeviceId
                            });
                        case 13:
                            authNResponse = _ctx1.sent;
                            accessToken1 = authNResponse.accessToken, mvpd = authNResponse.mvpd;
                            if (!(accessToken1 || mvpd)) {
                                _ctx1.next = 23;
                                break;
                            }
                            redirect = (function() {
                                var _ref = _asyncToGenerator(_home_jenkins_workspace_dcg_web_PROD_go_fox_com_static_s3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                                    var ref;
                                    return _home_jenkins_workspace_dcg_web_PROD_go_fox_com_static_s3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                ;
                                                _ctx.next = 3;
                                                return router.push(process.env.NEXT_PUBLIC_DELTA_SITE_URL || (state === null || state === void 0 ? void 0 : (ref = state.config) === null || ref === void 0 ? void 0 : ref.siteUrl));
                                            case 3:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee);
                                }));
                                return function redirect() {
                                    return _ref.apply(this, arguments);
                                };
                            })();
                            successTimer = setTimeout(redirect, constants_index__WEBPACK_IMPORTED_MODULE_13__/* .REDIRECT_SECONDS */ .yk * 1000);
                            dispatch((0,context_state_reducer__WEBPACK_IMPORTED_MODULE_11__/* .setFlowStage */ .Kc)(constants_index__WEBPACK_IMPORTED_MODULE_13__/* .FLOW_STAGE_MVPD_LINK */ .Bi));
                            (0,lib_analytics_trackCalls__WEBPACK_IMPORTED_MODULE_9__/* .handleTrackEvent */ .GV)({
                                eventName: lib_analytics_trackCalls__WEBPACK_IMPORTED_MODULE_9__/* .Events.PROFILE_ACCESS_ACTIVATION_COMPLETED */ .zW.PROFILE_ACCESS_ACTIVATION_COMPLETED
                            });
                            return _ctx1.abrupt("return");
                        case 23:
                            _ctx1.next = 25;
                            return router.push(constants_index__WEBPACK_IMPORTED_MODULE_13__/* .ROUTE_HOME */ .XX);
                        case 25:
                            return _ctx1.abrupt("return");
                        case 28:
                            _ctx1.prev = 28;
                            _ctx1.t0 = _ctx1["catch"](5);
                            dispatch((0,context_state_reducer__WEBPACK_IMPORTED_MODULE_11__/* .setError */ .sT)(_ctx1.t0));
                            _ctx1.next = 33;
                            return router.push(constants_index__WEBPACK_IMPORTED_MODULE_13__/* .ROUTE_HOME */ .XX);
                        case 33:
                        case "end":
                            return _ctx1.stop();
                    }
                }, _callee1, null, [
                    [
                        5,
                        28
                    ]
                ]);
            }));
            return function validateAuth() {
                return _ref1.apply(this, arguments);
            };
        }();
        validateAuth();
        return function() {
            clearTimeout(successTimer);
        };
    }, [
        cookies,
        dispatch,
        profile,
        router,
        state === null || state === void 0 ? void 0 : (ref5 = state.config) === null || ref5 === void 0 ? void 0 : ref5.siteUrl
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledSuccess, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("h1", {
                children: [
                    "Thank you for signing in ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                    "with your TV Provider."
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                children: [
                    "You may now return to your TV to begin your ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                    "enhanced streaming experience."
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common__WEBPACK_IMPORTED_MODULE_12__/* .Loader */ .aN, {})
        ]
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (Success);
var StyledSuccess = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-a66a11f2-0"
})(_templateObject1(), styles_helper__WEBPACK_IMPORTED_MODULE_5__/* .respondTo.bp_767 */ .s.bp_767(_templateObject()), styles_colors__WEBPACK_IMPORTED_MODULE_4__/* ["default"].white25 */ .ZP.white25);


/***/ }),

/***/ 1163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(387)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [130,513,774,888,179], function() { return __webpack_exec__(8559); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);